// extracted by mini-css-extract-plugin
export default {"formItem":"CouponInfo_formItem__afehh","input":"CouponInfo_input__vXdM8","inputError":"CouponInfo_inputError__gqgTp","errorMessage":"CouponInfo_errorMessage__0kGiD"};